import "./App.css";
import React from "react";
import { StarekContextProvider } from "./context/StarekContext";
import StarekApp from "./StarekApp";

function App() {
    return (
        <StarekContextProvider>
            <StarekApp></StarekApp>
        </StarekContextProvider>
    );
}

export default App;
